import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { createAdminWorkspace, registerWorkspace } from '@/api/onboarding/onboardingApi';
import type {
  AdminWorkspaceCreation,
  CreateAdminWorkspacePayload,
  RegisterWorkspacePayload,
  WorkspaceRegistration,
} from '@/api/onboarding/onboardingApi.types';
import { INVITATIONS_QUERY_KEY, TENANTS_QUERY_KEY } from '@/constants/queryKeys';

export function useRegisterWorkspaceMutation(): UseMutationResult<
  WorkspaceRegistration,
  Error,
  RegisterWorkspacePayload
> {
  return useMutation({
    mutationFn: registerWorkspace,
  });
}

export function useCreateAdminWorkspaceMutation(): UseMutationResult<
  AdminWorkspaceCreation,
  Error,
  CreateAdminWorkspacePayload
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createAdminWorkspace,
    onSuccess: function invalidateTenantsAndInvitations() {
      queryClient.invalidateQueries({ queryKey: TENANTS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: INVITATIONS_QUERY_KEY });
    },
  });
}
